import React from 'react';
import { Phone, MapPin, MessageCircle, Clock } from 'lucide-react';
import Reveal from './Reveal';

const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-zinc-950 border-t border-zinc-900 relative overflow-hidden" data-testid="contact-section">
      {/* Decorative element */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-yellow-500/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">

          <Reveal>
            <h2 className="text-sm font-bold text-yellow-500 tracking-[0.3em] uppercase mb-3">Bize Ulaşın</h2>
            <h3 className="font-display text-3xl md:text-4xl font-semibold text-white mb-8">İletişim Bilgileri</h3>
            <p className="text-zinc-400 mb-12 text-base md:text-lg">
              Rezervasyon, fiyat bilgisi ve diğer sorularınız için 7/24 bizimle iletişime geçebilirsiniz.
            </p>

            <div className="space-y-8">
              <div className="flex items-start gap-6 group">
                <div className="w-14 h-14 shrink-0 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center text-yellow-500 group-hover:bg-yellow-500 group-hover:text-black transition-colors">
                  <Phone size={24} />
                </div>
                <div>
                  <h4 className="text-sm text-zinc-500 mb-2">Telefon ile Ara</h4>
                  <div className="flex flex-col gap-2">
                    <a href="tel:+905416410171" data-testid="contact-phone-1" className="text-2xl font-semibold text-white hover:text-yellow-500 transition-colors">+90 541 641 01 71</a>
                    <a href="tel:+905353770031" data-testid="contact-phone-2" className="text-2xl font-semibold text-white hover:text-yellow-500 transition-colors">+90 535 377 00 31</a>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-6 group">
                <div className="w-14 h-14 shrink-0 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center text-green-500 group-hover:bg-green-500 group-hover:text-black transition-colors">
                  <MessageCircle size={24} />
                </div>
                <div>
                  <h4 className="text-sm text-zinc-500 mb-2">WhatsApp'tan Yaz</h4>
                  <div className="flex flex-col gap-2">
                    <a href="https://wa.me/905416410171" target="_blank" rel="noreferrer" data-testid="contact-whatsapp-1" className="text-2xl font-semibold text-white hover:text-green-500 transition-colors">+90 541 641 01 71</a>
                    <a href="https://wa.me/905353770031" target="_blank" rel="noreferrer" data-testid="contact-whatsapp-2" className="text-2xl font-semibold text-white hover:text-green-500 transition-colors">+90 535 377 00 31</a>
                  </div>
                </div>
              </div>

              <a href="https://maps.app.goo.gl/HPXZfFoa4Z4pnfBG6" target="_blank" rel="noreferrer" data-testid="contact-address-link" className="flex items-start gap-6 group">
                <div className="w-14 h-14 shrink-0 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center text-yellow-500 group-hover:bg-yellow-500 group-hover:text-black transition-colors">
                  <MapPin size={24} />
                </div>
                <div>
                  <h4 className="text-sm text-zinc-500 mb-1">Açık Adres</h4>
                  <p className="text-lg text-white leading-relaxed group-hover:text-yellow-500 transition-colors">
                    Meydan Mah. Şht. J. Er Veysel Aktı Cd. No:21<br/>
                    31300 İskenderun / Hatay
                  </p>
                </div>
              </a>

              <div className="flex items-start gap-6">
                <div className="w-14 h-14 shrink-0 rounded-full bg-zinc-900 border border-zinc-800 flex items-center justify-center text-yellow-500">
                  <Clock size={24} />
                </div>
                <div>
                  <h4 className="text-sm text-zinc-500 mb-1">Çalışma Saatleri</h4>
                  <p className="text-lg text-white">7 Gün 24 Saat Hizmetinizdeyiz</p>
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="mt-8 lg:mt-0">
            <div className="bg-zinc-900 rounded-3xl p-2 border border-zinc-800 shadow-2xl h-[400px] lg:h-full overflow-hidden relative group" data-testid="contact-map-card">
              <a
                href="https://maps.app.goo.gl/HPXZfFoa4Z4pnfBG6"
                target="_blank"
                rel="noreferrer"
                data-testid="contact-map-link"
                className="absolute inset-0 z-10 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl m-2"
              >
                <span className="bg-yellow-500 text-black font-semibold px-6 py-3 rounded-full shadow-lg transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  Haritada Aç
                </span>
              </a>
              <iframe
                src="https://maps.google.com/maps?q=İskenderun%20Konaklama,%20Meydan,%20Şht.%20J.%20Er%20Veysel%20Aktı%20Cd.%20No:21,%2031300%20İskenderun/Hatay&t=&z=16&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full rounded-2xl filter grayscale contrast-125 opacity-80 group-hover:opacity-50 transition-opacity"
                style={{border:0}}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="İskenderun Konaklama Harita"
                data-testid="contact-map-iframe"
              ></iframe>
            </div>
          </Reveal>

        </div>
      </div>
    </section>
  );
};

export default Contact;
